import { useContext, useEffect } from 'react';
import { useGetAnnualStatements } from '@app/sdk';
import { AccountContext, useAccountContext } from '../../AccountContext';
import { Button, MessageHeader, MessageContent, Message, Icon, Label, TransitionGroup } from 'semantic-ui-react';

export default function AnnualStatementSelector() {
  const { accountId } = useContext(AccountContext);
  const { data: annualStatements } = useGetAnnualStatements(accountId);
  const { setAnnualStatementId } = useAccountContext();

  useEffect(() => {
    if (annualStatements?.value?.length > 0) {
      setAnnualStatementId(annualStatements.value[0].annualStatementId);
    }
  }, [annualStatements]);

  return (
    <>
      <div className="ui">
        {annualStatements?.value?.map((annualStatement) => (
          <Button
            key={annualStatement.annualStatementId}
            style={{ marginBottom: '5px' }}
            icon="file alternate"
            className="ui button"
            labelPosition="left"
            
            content={
              <div>
                Annual Statement {annualStatement.annualStatementId}
                <div className="ui grey sub header">
                  bp {annualStatement.firstIncludedBillingPeriodId}-{annualStatement.lastIncludedBillingPeriodId}
                </div>
              </div>
            }
            onClick={() => setAnnualStatementId(annualStatement.annualStatementId)}
          />
        ))}
      </div>
    </>
  );
}
